export const UNCATEGORIZED_VALUE = ''
export const UNCATEGORIZED_LABEL = 'Uncategorized'
export const MIXED_CATEGORIES_LABEL = 'Mixed categories'
export const SECONDS = 1000;

/**
 * Operation Center URL for mithra staff
 */
export const STAFF_DEVOPS_CENTER_URL = 'https://operations-center.mithra-ai.nl/';
